<div class="max-w-md mx-auto flex flex-col mt-4 relative overflow-hidden">
  <div class="flex justify-center item-center mt-10">
    <h6 class="text-2xl font-semibold text-gray-800">
      Create a new
      <span class="italic">Diagnostic Trouble Code</span>
      for
      <span class="text-amazone-orange">{{ swPartNumber }}</span>
    </h6>
  </div>
  <form [formGroup]="form">
    <div
      class="grid gap-6 mt-6 md:grid-cols-6 border-b border-gray-900/10 pb-6 overflow-y-auto h-[calc(100vh-12rem)] px-4"
    >
      <div class="col-span-full">
        <div class="grid gap-6 mb-6 md:grid-cols-2">
          <div>
            <app-label-with-help for="priority" class="primary-label" fieldConfigurationAddress="dtc.priority"
              >Priority</app-label-with-help
            >
            <input
              type="number"
              id="priority"
              class="primary-machine-field"
              placeholder="e.g. 0 - 255"
              min="0"
              max="255"
              required
              [formControl]="priority"
            />
            @if (priority.touched && priority.hasError('min')) {
              <span class="text-red-600 text-sm font-extralight">0 is the lowest value</span>
            }
            @if (priority.touched && priority.hasError('max')) {
              <span class="text-red-600 text-sm font-extralight">255 is the highest value</span>
            }
            @if (priority.touched && priority.hasError('required')) {
              <span class="text-red-600 text-sm font-extralight">A value is required</span>
            }
          </div>
          <div>
            <app-label-with-help for="group" class="primary-label" fieldConfigurationAddress="dtc.group"
              >Group</app-label-with-help
            >
            <input
              type="number"
              id="group"
              class="primary-machine-field"
              placeholder="255"
              min="0"
              max="255"
              [defaultValue]="255"
              required
              [formControl]="group"
            />
            @if (group.touched && group.hasError('min')) {
              <span class="text-red-600 text-sm font-extralight">0 is the lowest value</span>
            }
            @if (group.touched && group.hasError('max')) {
              <span class="text-red-600 text-sm font-extralight">255 is the highest value</span>
            }
            @if (group.touched && group.hasError('required')) {
              <span class="text-red-600 text-sm font-extralight">A value is required</span>
            }
          </div>
        </div>
      </div>
      <div class="col-span-full">
        <app-text-area
          [fieldIsRequired]="true"
          [placeholder]="'Describe the error in a few words'"
          [fieldConfigurationAddress]="'dtc.implementationHint'"
          [label]="'Implementation Hint'"
          [formControl]="implementationHint"
          [borderColorClass]="'border-machine-field focus:ring-machine-field focus:border-machine-field'"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>

      <div class="inline-flex items-center justify-center col-span-full">
        <div class="flex-grow border-t border-gray-200"></div>
        <span class="mx-4 text-sm text-gray-500 dark:text-gray-500"> optional </span>
        <div class="flex-grow border-t border-gray-200"></div>
      </div>

      <div class="col-span-full">
        <app-text-area
          [label]="'Details on terminal'"
          [fieldConfigurationAddress]="'dtc.detailsOnTerminal'"
          [fieldIsRequired]="false"
          [formControl]="detailsOnTerminal"
          [borderColorClass]="'border-terminal-field focus:ring-terminal-field focus:border-terminal-field'"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Cause (Farmer)'"
              [fieldConfigurationAddress]="'dtc.causeFarmer'"
              [formControl]="causeFarmer"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>

        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Remedy (Farmer)'"
              [fieldConfigurationAddress]="'dtc.remedyFarmer'"
              [formControl]="remedyFarmer"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Cause (Dealer)'"
              [fieldConfigurationAddress]="'dtc.causeDealer'"
              [formControl]="causeDealer"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>

        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Remedy (Dealer)'"
              [fieldConfigurationAddress]="'dtc.remedyDealer'"
              [formControl]="remedyDealer"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>
      </div>

      <div
        class="col-span-full grid gap-y-2 border border-amazone-gray-light/30 rounded-md p-4 hover:shadow-lg transition-shadow duration-300"
      >
        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Cause (Intern)'"
              [fieldConfigurationAddress]="'dtc.causeIntern'"
              [formControl]="causeIntern"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>

        <div class="col-span-full">
          <div class="mt-2">
            <app-text-area
              [label]="'Remedy (Intern)'"
              [fieldConfigurationAddress]="'dtc.remedyIntern'"
              [formControl]="remedyIntern"
              [rows]="3"
              [displayChangeIndicator]="false"
            ></app-text-area>
          </div>
        </div>
      </div>

      <div class="col-span-full pt-4">
        <app-text-area
          [label]="'Internal notes'"
          [fieldConfigurationAddress]="'dtc.internalNotes'"
          [fieldIsRequired]="false"
          [formControl]="internalNotes"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>
      <div class="col-span-full flex justify-end">
        <button
          data-tooltip-target="tooltip-generate"
          type="button"
          [disabled]="form.invalid"
          (click)="createDtc()"
          class="crud-btn-create"
          appAgentAction
          agent="new-dtc-create"
          businessObject="dtc"
          action="create"
        >
          <app-floppy-icon></app-floppy-icon>
        </button>
        <div
          id="tooltip-generate"
          role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
        >
          {{ tooltipText }}
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>
    </div>
  </form>
</div>
<app-propagate-created-entity-modal #propagateCreatedEntityModal></app-propagate-created-entity-modal>
